import type {
  DeliveryVoucherIndicatorType,
  InvoiceDeliveryVoucher,
} from 'contracts/DeliveryVouchers';
import type { DeliveryVoucherFilters } from 'hooks/store/delivery-vouchers';

export const hasActiveDeliveryVoucherFilters = (
  filters: DeliveryVoucherFilters
) => {
  // O checkbox de CNPJ raiz só altera a busca quando existe transportadora selecionada.
  const { sameCarrierCnpj, ...filterValues } = filters;

  return Object.values(filterValues).some(value => !!value);
};

export const getLatestDeliveryVoucher = (invoice: InvoiceDeliveryVoucher) => {
  const voucher = invoice.deliveryVoucher?.[0];

  return voucher?.id ? voucher : undefined;
};

export const getDeliveryVoucherInvoiceOrigin = (
  invoice: InvoiceDeliveryVoucher
) => {
  const city = invoice.originCity?.name || invoice.supplier.addressCity;
  const uf = invoice.originCity?.uf || invoice.supplier.addressUf;

  return [city, uf].filter(Boolean).join('/');
};

export const getDeliveryVoucherInvoiceDestination = (
  invoice: InvoiceDeliveryVoucher
) => {
  const city = invoice.destinationCity?.name || invoice.company.addressCity;
  const uf = invoice.destinationCity?.uf || invoice.company.addressUf;

  return [city, uf].filter(Boolean).join('/');
};

export const getDeliveryVoucherStatus = (
  invoice: InvoiceDeliveryVoucher
): DeliveryVoucherIndicatorType => {
  const voucher = getLatestDeliveryVoucher(invoice);

  if (!voucher) return 'waitingVoucher';
  if (voucher.rejectedAt) return 'voucherRejected';
  if (!voucher.approvedAt) return 'waitingApproval';

  return voucher.userId ? 'approvedManual' : 'approvedAutomatic';
};
